import apiClient from './api';
import type { OAuthClient, PaginatedResponse, PaginationParams } from '@/types';

export const oauthService = {
  /**
   * Get paginated list of OAuth clients
   */
  async getClients(params?: PaginationParams): Promise<PaginatedResponse<OAuthClient>> {
    const { data } = await apiClient.get<PaginatedResponse<OAuthClient>>('/oauth/clients', { params });
    return data;
  },

  /**
   * Get single OAuth client by ID
   */
  async getClient(id: string): Promise<OAuthClient> {
    const { data } = await apiClient.get<OAuthClient>(`/oauth/clients/${id}`);
    return data;
  },

  /**
   * Create new OAuth client
   */
  async createClient(clientData: Partial<OAuthClient>): Promise<OAuthClient> {
    const { data } = await apiClient.post<OAuthClient>('/oauth/clients', clientData);
    return data;
  },

  /**
   * Delete OAuth client
   */
  async deleteClient(id: string): Promise<void> {
    await apiClient.delete(`/oauth/clients/${id}`);
  },

  /**
   * Get OAuth tokens
   */
  async getTokens(params?: PaginationParams) {
    const { data } = await apiClient.get('/oauth/tokens', { params });
    return data;
  },

  /**
   * Revoke OAuth token
   */
  async revokeToken(tokenId: string): Promise<void> {
    await apiClient.post('/oauth/revoke', { token_id: tokenId });
  },
};
